<template>
    <div>
        <kgr-club-cost-center-provider
            v-slot="clubCostCentersScope"
            :club-id="clubId"
            :callback="onLoaded"
        >
            <kgr-form-scaffold
                :with-back-button="false"
                :pending="pending"
                :save-button-disabled="saveButtonDisabled"
                @primaryBtnClicked="update(clubCostCentersScope.reload)"
                ref="top"
            >
                <div class="animated fadeIn">
                    <div class="kgr-row">
                        <kgr-club-cost-center-form
                            :error="error"
                            :club-cost-centers="clubCostCenters"
                            class="animated fadeIn"
                            @enter="update(clubCostCentersScope.reload)"
                            @change="updateCostCenters($event)"
                        />
                    </div>
                </div>
            </kgr-form-scaffold>
        </kgr-club-cost-center-provider>
    </div>
</template>

<script>
import ClubCostCenterForm from '../../../components/club/cost-centers/ClubCostCenterForm.vue';
import ClubCostCenterProvider from '../../../components/data-provider/ClubCostCenterProvider.vue';
import ClubCostCenterRepositoryRepository from '../../../js/repository/ClubCostCenterRepository.js';
import Error from '../../../js/model/Error.js';
import FormScaffold from '../../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-club-cost-center-form': ClubCostCenterForm,
        'kgr-club-cost-center-provider': ClubCostCenterProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            clubCostCenters: [],
        };
    },
    computed: {
        saveButtonDisabled() {
            return this.clubCostCenters.length === 0;
        },
    },
    methods: {
        onLoaded(loadedClubCostCenters) {
            this.clubCostCenters = loadedClubCostCenters;
        },
        update(reload) {
            this.pending = true;
            ClubCostCenterRepositoryRepository.updateClubCostCenters(this.clubId, this.clubCostCenters)
                .then(() => {
                    this.error = new Error();
                    reload();
                    this.$notify.success('saveChanges.success');
                    this.scrollToTop();
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                })
                .finally(() => this.pending = false);
        },
        updateCostCenters(clubCostCenters) {
            this.clubCostCenters = clubCostCenters;
        },
        scrollToTop() {
            this.$refs.top.$el.scrollIntoView({ behavior: 'smooth' });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
